export default "/images/4f9a5ec96e0f9d6658baa33235f98841.png";